import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useSpring, a, config} from 'react-spring';
import { useDrag } from 'react-use-gesture';

import {
  OPEN_STORY,
  CLOSE_STORY
} from 'shared/actions/types';

const ActionSheet = ({ props, children }) => {
  const { user, story } = props;
  const height = window.innerHeight;
  const scroller = useRef();
  const backdrop = useRef();
  const dispatch = useDispatch();

  const [{ y }, setSpring] = useSpring(() => ({
    y: height
  }));

  //const [backdropStyle, backdropApi] = useSpring({
  //  position: 'fixed',
  //  zIndex: 3,
  //  top: height + 'px',
  //  left: 0,
  //  right: 0,
  //  bottom: 0,
  //  background: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9))'
  //}, []);

  //const backdropStyle = {
  //  position: 'fixed',
  //  zIndex: 3,
  //  top: height + 'px',
  //  left: 0,
  //  right: 0,
  //  bottom: 0,
  //  background: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9))',
  //  transition: 'top 0.3s'
  //}

  //const showBackdrop = () => {
    //if (backdrop.current) {
    //  backdrop.current.style.top = 0;
    //}
    //backdropApi.start({top: 0});
    //backdropSet({top: '0px'});
    //if (backdrop.current) {
    //  backdrop.current.style.top = 0;
    //}
    //backdropStyle.top.start({from: height + 'px', to: 0});
  //}

  //const hideBackdrop = () => {
    //if (backdrop.current) {
    //  backdrop.current.style.top = height + 'px';
    //}
    //backdropApi.start({top: height + 'px'});
    //backdropSet({top: height + 'px'});
    //if (backdrop.current) {
    //  backdrop.current.style.top = height + 'px';
    //}
    //backdropStyle.top.start({from: 0, to: height + 'px'});
  //}

  const open = ({ canceled }) => {
    dispatch({
      type: OPEN_STORY,
      payload: { user, story }
    });

    //showBackdrop();

    // hotfix, won't work for ActionSheets over ActionSheets
    document.body.style.overflowY = 'hidden';

    // when cancel is true, it means that the user passed the upwards threshold
    // so we change the spring config to create a nice wobbly effect
    setSpring.start({
      y: 0,
      immediate: false,
      config: canceled ? config.molasses : config.stiff,
      //config: {
      //  ...config.wobbly
      //},
      duration: props.openDuration || 1500
    });
  }

  const close = (velocity = 0) => {
    dispatch({
      type: CLOSE_STORY,
      payload: { user, story }
    });

    //hideBackdrop();

    setSpring.start({
      y: height,
      immediate: false,
      config: {
        ...config.gentle,
        velocity,
        duration: props.closeDuration || 200
      }
    });

    setTimeout(() => {
      // hotfix, won't work for ActionSheets over ActionSheets
      document.body.style.overflowY = 'scroll';
    }, 300);
  }

  const bind = useDrag(
    ({ event, last, vxvy: [, vy], movement: [, my], cancel, canceled }) => {
      // hotfix to prevent swiping through photoswipe when its open
      if (window.actionSheetDisabled) {
        return;
      }

      // if the user drags up passed a threshold, then we cancel
      // the drag so that the sheet resets to its open position
      //if (my < -70) cancel();
      if (my < 0) {
        //vy > 0.5 ? close() : cancel();
        cancel();
      }

      // when the user releases the sheet, we check whether it passed
      // the threshold for it to close, or if we reset it to its open position
      if (last) {
        if (scroller.current && scroller.current.scrollTop === 0 && vy > 0.3) {
          close(vy);
        } else {
          open({ canceled });
        }
        //my > height * 0.5 || vy > 0.5 ? close(vy) : open({ canceled });
        //my > height * 0.5 || vy > 1 ? close(vy) : open({ canceled });
      }

      // // when the user keeps dragging, we just move the sheet according to
      // // the cursor position
      // else setSpring.start({ y: my, immediate: true });
    },
    {
      initial: () => [0, y.get()],
      filterTaps: true,
      bounds: { top: 0, bottom: height * 0.5 },
      rubberband: props.rubberband || 1,
      preventDefault: true,
      axis: 'y'
    }
  );

  const display = y.to(py => (py < height ? 'block' : 'none'));

  const bgStyle = {
    transform: y.to([0, height], [
      'translateY(-8%) scale(1.16)',
      'translateY(0px) scale(1.05)'
    ]),
    opacity: y.to([0, height], [0.4, 1], 'clamp')
  }

  let background = null;
  if (props.background) {
    background = (
      <a.div onClick={() => close()} style={bgStyle}>
	{props.background}
      </a.div>
    );
  }

  const contentStyle = {
    position: 'fixed',
    zIndex: 3,
    top: 0,
    right: 0, // on desktop the nav will be on the left
    display,
    bottom: `calc(-100vh + ${height - 100}px`,
    y,
    height: '100vh',
    overflowY: 'auto'
  }

  //const backdropStyle = {
  //  position: 'fixed',
  //  zIndex: 3,
  //  top: 0,
  //  left: 0,
  //  right: 0,
  //  bottom: 0,
  //  background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.9))',
  //  pointerEvents: 'none',
  //  ...backdropStyle
  //};

  const scrollerId = "scroller-" + story.id;

  return (
    <div>
      {background}
      <div onClick={open}>
        {props.button}
      </div>
      <a.div id={scrollerId} ref={scroller} {...bind()} style={contentStyle}>
        {React.cloneElement(props.content, {
          close: () => close(),
          //hideBackdrop: () => hideBackdrop(),
          scrollNode: scroller,
          scrollerId: scrollerId
        })}
      </a.div>
    </div>
  );

  //return (
  //  <div>
  //    {background}
  //    <div onClick={open}>
  //      {props.button}
  //    </div>
  //    <a.div ref={backdrop} style={backdropStyle} />
  //    <a.div id={scrollerId} ref={scroller} {...bind()} style={contentStyle}>
  //      {React.cloneElement(props.content, {
  //        close: () => close(),
  //        hideBackdrop: () => hideBackdrop(),
  //        scrollNode: scroller,
  //        scrollerId: scrollerId
  //      })}
  //    </a.div>
  //  </div>
  //);
}

export default ActionSheet;
